{
  "common": {
    "appName": "Partake",
    "appDownloadPrompt": {
      "guest": "Like what you see? Get Partake on your phone and receive new availability near you",
      "qrCodeAccessibilityLabel": "QR code to download the Partake app"
    },
    "postalCodeRequiredError": "Please enter a zip code"
  },
  "contact-information": {
    "title": "Your Zip Code",
    "prompt": "Input your zip code to discover everything you can borrow near you!",
    "invalidAddressError": "Invalid zip code. Please try again.",
    "changePostalCode": "Change my zip code"
  },
  "contact-us": {
    "firstParagraph": "Partake member service is available by email and in-app messaging. We will respond to you as quickly as possible.",
    "faqLink": "https://www.we-partake.com/en-us/about/frequently-asked-questions"
  },
  "free-sub": {
    "headerTextNotYet": "You are helping grow the <strong>Partake</strong> catalog!"
  },
  "guidelines": {
    "fifthParagraph": "Do not use Partake to sell objects."
  },
  "help": {
    "compensation": {
      "subscribeText": "With a subscription, Partake compensates you up to $300 on items you lend and borrow."
    }
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Join Partake"
      }
    }
  },
  "introModal": {
    "pageTitle": {
      "newly_insured": "The Partake Responsibility"
    },
    "titleNewFeature": "Partake takes responsibility!",
    "welcome": {
      "regular": "<strong>Welcome to the Club!</strong>\nAs an official member of Partake, your subscription unlocks new benefits."
    },
    "custom": {
      "support": "<strong>Is something damaged? Do you have an issue? Our team is available to assist you anytime.</strong>"
    }
  },
  "landing-page": {
    "immature": {
      "writeToMayor": {
        "title": "Ask your city to offer Partake to its citizens"
      }
    }
  },
  "insured": {
    "landing-page": {
      "title": "Partake Responsibility"
    },
    "listing": {
      "text": {
        "own": "With your subscription, you’re covered by the Partake Responsibility in case your items are damaged.",
        "other": "With their subscription, {{name}} is covered by the Partake Responsibility in case their items are damaged."
      }
    },
    "myPlan": {
      "title": "Covered by Partake",
      "text": "By subscribing, you benefit from Partake Responsibility if an item you lend or borrow gets damaged."
    },
    "profile": {
      "title": "{{name}} is covered by the Partake Responsibility in case their items are damaged."
    },
    "details": {
      "title": "Partake Responsibility"
    }
  },
  "invite": {
    "referralProgram": {
      "title": "Love Partake?\n<color>For each referral</color> we give you <color>1 free month!</color>",
      "details": "Each time a friend subscribes using your referral link, you get 1 free month at Partake.",
      "referrals": {
        "subTitle_one": "<strong>{{count}} person</strong> joined Partake thanks to <strong>you</strong> 🥳",
        "subTitle": "<strong>{{count}} people</strong> joined Partake thanks to <strong>you</strong> 🥳"
      },
      "gift": {
        "prefix": "For each person you refer, you automatically get one free month at Partake."
      },
      "shareText": "Hey!\n\nI’ve been using Partake, an app to share everyday items. It’s super handy and I’m sure you’ll love it. Join me:\n\n{{url}}"
    },
    "referralProgram202506": {
      "title": "Love Partake?\n<color>Invite 5 friends</color> and get <color>a gift worth $25!</color>",
      "shareText": "Hey!\n\nI’ve been using Partake, an app to share everyday items. It’s super handy and I’m sure you’ll love it. Join me:\n\n{{url}}"
    },
    "shareText": "Hey!\n\nI’ve been using Partake, an app to share everyday items. It’s super handy and I’m sure you’ll love it. Join me:\n\n{{url}}",
    "referrals": {
      "subTitle_one": "<strong>{{count}} person</strong> joined Partake thanks to <strong>you</strong> 🥳",
      "subTitle": "<strong>{{count}} people</strong> joined Partake thanks to <strong>you</strong> 🥳"
    }
  },
  "my-address": {
    "postalCodeFieldLabel": "Zip Code"
  },
  "my-neighbourhood": {
    "postalCodeLabel": "Zip Code"
  },
  "my-plan": {
    "businessPlan": {
      "title": {
        "municipal": "Partake+ Subscription",
        "municipal_closed": "Partake+ Subscription"
      }
    },
    "design": {
      "shareReferral": "Join me on Partake: {{url}}"
    },
    "freeSubText": {
      "trial": "Help grow the <strong>Partake</strong> catalog! Post 5 offers and get a <strong>free annual subscription</strong>!"
    },
    "referralProgram": {
      "subtitle": "For each person you refer, you automatically get one free month at Partake."
    }
  },
  "notifications": {
    "impactLevelExplorerMessage": "Begin your Partake experience. Publish something to grow your impact and move to the next level.",
    "introModal": {
      "intro": {
        "title": "Welcome to the club",
        "body": "Discover Partake!"
      },
      "b2c_paid": {
        "body": "As an official member of Partake, your subscription unlocks new benefits."
      },
      "newly_insured": {
        "title": "Partake takes responsibility!"
      }
    },
    "newReferralSubscribed": {
      "receivedPrizeMessage": "Congrats! 🥳 You have just won a free annual subscription to Partake!",
      "receivedMonthPrizeMessage": "Congrats! 🥳 You have just won a free month to Partake!"
    },
    "welcome": "Welcome to Partake!",
    "rate": {
      "borrower": {
        "message": "Your opinion is important to us and to other members of Partake."
      },
      "lender": {
        "message": "Your opinion is important to us and to other members of Partake."
      }
    }
  },
  "one-channel": {
    "firstLoanPrompt": {
      "description": "This first borrow is entirely offered by Partake"
    },
    "notifNowInsured": "<strong>Rest assured and share!\n\nPartake can compensate you up to $300</strong> if anything happens to loaned items worth $25 or more.\nIf needed, can contact us here, or by email at <strong>info@partage.club</strong>",
    "levelModal": {
      "superSharer": {
        "message": "You've increased your impact by completing 5 shares! You're at the top level: <strong>Super Sharer</strong> and an example to follow at the Partake.\n\nWell done! With each share, you grow your impact for a greener future."
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "The need has been fulfilled on the Partake"
      }
    }
  },
  "payment": {
    "mobileRedirect": {
      "subtitle": "The Partake subscription is currently only available on the mobile app.\nOnce subscribed, you can continue using the website to borrow and lend items."
    }
  },
  "paywall": {
    "redesign": {
      "coverageFootnote": "*Partake Responsibility covers up to $300 for items that are lent or borrowed."
    },
    "thirdFeature": "Partake is responsible for damages to items."
  },
  "paywall2": {
    "offer": {
      "trial": "Save 25% on the annual subscription and get coverage with Partake Responsibility!"
    }
  },
  "presentPartageClub": {
    "headerTitle": "Welcome to Partake",
    "title": "Welcome to Partake",
    "community": {
      "headerText": "Partake is the application for <strong>sharing objects</strong> between neighbors."
    },
    "accessMore": {
      "headerText": "With Partake, you access an <strong>abundance of objects</strong>."
    },
    "offerMore": {
      "headerText": "With Partake, your <strong>generosity</strong> makes a real <strong>difference</strong>."
    }
  },
  "presentCommunity": {
    "headerTitle": "Welcome to the community",
    "title": "Welcome to the community",
    "newFlow": {
      "coverageFootnote": "*Partake Responsibility covers up to $300 for items that are lent or borrowed."
    },
    "responsibility": {
      "headerText": "Partake is <strong>responsible</strong>!"
    },
    "transaction": {
      "headerText": "With Partake, there is <strong>no exchange of money</strong>"
    },
    "trust": {
      "headerText": "With Partake, <strong>trust</strong> comes <strong>first</strong>"
    },
    "free": {
      "headerText": "With Partake, <strong>trust</strong> comes <strong>first</strong>"
    }
  },
  "privacy": {
    "link1": "https://www.we-partake.com/en-us/terms-and-conditions",
    "link2": "https://www.we-partake.com/en-us/privacy-policy",
    "button3Text": "Responsabilité du Partake",
    "link3": "https://www.we-partake.com/en-us/terms-and-conditions#responsabilite"
  },
  "quick-new-thanks": {
    "bodyText": "You have just contributed to expanding the <strong>Partake</strong> catalog!"
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contact Partake"
    },
    "newRating": {
      "commentHelp": "Visible only to the Partake team. Use this to flag issues or share useful context."
    }
  },
  "neighbour-profile": {
    "reviews": {
      "sheet": {
        "paragraph1": "On Partake, ratings help build a trusted community for safer sharing."
      }
    }
  },
  "trialPromo": {
    "title": "Help grow the Partake catalog and win your subscription!",
    "details": "Help grow the <strong>Partake</strong> catalog! Publish 5 offers and win your <strong>annual subscription</strong>! 🥳"
  },
  "tutorial": {
    "publishOffers": {
      "step1": {
        "text": "Here, <strong>trust</strong> prevails. All members commit to respecting the golden rules.\n\nIn case of any problem, <strong>the Partake team</strong> is at your service at any time. (1/5)"
      }
    }
  },
  "ambassador": {
    "description": {
      "isAmbassador": "An ambassador is an engaged member who <strong>actively contributes to bringing sharing to life in their community</strong>. They act as a <strong>local landmark</strong>, facilitate exchanges and help Partake grow in a human and authentic way.",
      "notYetAmbassador": "An ambassador is an engaged member who <strong>actively contributes to bringing sharing to life in their community</strong>. They act as a <strong>local landmark</strong>, facilitate exchanges and help Partake grow in a human and authentic way."
    },
    "advantages": {
      "advantage3": {
        "body": "Share your opinion on future priorities and projects for Partake and the ambassador program"
      },
      "advantage4": {
        "title": "Special Partake event invitations"
      },
      "advantage5": {
        "title": "Access to items provided by Partake"
      }
    },
    "mission": {
      "concrete1": "Spread the word about Partake"
    }
  }
}
